import { numericExtent, volOscSeries } from "../utils";
const VOLOSC = {
    name: "VOLOSC",
    compute: (bars, shortPeriod = 5, longPeriod = 20) => volOscSeries(bars, shortPeriod, longPeriod),
    computeExtents: (values) => numericExtent(values),
    render: () => undefined,
};
export default VOLOSC;
